import Header from './components/Header';
import Hero from './components/Hero';
import Brands from './components/Brands';
import CategoryWomen from './components/CategoryWomen';
import CategoryMen from './components/CategoryMen';
import Heritage from './components/Heritage';
import Recuerdos from './components/Recuerdos';
import Editorial from './components/Editorial';
import Instagram from './components/Instagram';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-cream-50 text-ink-900">
      <Header />
      <main>
        <Hero />
        <Brands />
        <CategoryWomen />
        <CategoryMen />
        <Heritage />
        <Recuerdos />
        <Editorial />
        <Instagram />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}